import React from 'react';
import { Link } from 'react-router-dom';

const LAST_UPDATE = '15/07/2026';
const VERSION = '1.0';
const CONTACT_EMAIL = 'spectrumvips@gmail.com';
const SITE = 'spectrumbots.site';

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-bold text-white mb-4">{title}</h2>
      <div className="space-y-3 text-slate-300 text-sm leading-relaxed">{children}</div>
    </section>
  );
}

function TermsOfUse() {
  return (
    <div className="min-h-screen bg-[#0f1419] text-slate-200">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <Link to="/" className="text-sm text-violet-400 hover:text-violet-300">
          ← Voltar
        </Link>

        <header className="mt-8 mb-12 border-b border-white/10 pb-8">
          <p className="text-sm font-semibold tracking-widest text-violet-400 uppercase">Spectrum</p>
          <h1 className="text-3xl font-bold text-white mt-2">Termos de Uso da Plataforma</h1>
          <ul className="mt-4 text-sm text-slate-400 space-y-1">
            <li><strong>Versão:</strong> {VERSION}</li>
            <li><strong>Vigência a partir de:</strong> {LAST_UPDATE}</li>
            <li><strong>Plataforma:</strong> {SITE}</li>
            <li><strong>Contato:</strong> {CONTACT_EMAIL}</li>
          </ul>
        </header>

        <p className="mb-10 text-slate-300 text-sm leading-relaxed">
          Bem-vindo(a) à Spectrum. Estes Termos de Uso estabelecem as condições aplicáveis ao acesso
          e à utilização da plataforma digital disponibilizada sob a denominação Spectrum, destinada
          à automação, gestão de acessos, cobranças, integrações e operacionalização de
          funcionalidades relacionadas a canais, grupos e bots no ambiente Telegram. Ao criar uma
          conta, acessar ou utilizar qualquer funcionalidade da Plataforma, o Usuário declara que
          leu, compreendeu e concorda integralmente com estes Termos de Uso. Caso não concorde,
          deverá abster-se de utilizar a Plataforma.
        </p>

        <Section title="1. Das Partes e da Plataforma">
          <p>
            1.1. Para fins destes Termos, "Spectrum" designa a plataforma digital disponibilizada ao
            Usuário por meio do site https://{SITE}/, bem como o conjunto de funcionalidades,
            integrações, recursos, interfaces, comunicações e serviços a ela vinculados, podendo ser
            contatada pelo e-mail {CONTACT_EMAIL}.
          </p>
          <p>
            1.2. A Spectrum consiste em plataforma de software disponibilizada no modelo SaaS
            (Software as a Service), destinada à criação, configuração, gestão e automação de bots,
            fluxos, acessos, assinaturas, disparos, integrações e funcionalidades relacionadas ao
            ambiente Telegram, incluindo integração com meios e gateways de pagamento.
          </p>
          <p>
            1.3. Considera-se "Usuário" toda pessoa física maior e capaz, bem como representante de
            pessoa jurídica, que realize cadastro e utilize as funcionalidades da Plataforma na
            qualidade de criador de conteúdo, infoprodutor, afiliado, revendedor ou outro perfil
            compatível com os serviços ofertados.
          </p>
          <p>
            1.4. A Spectrum atua exclusivamente como fornecedora de infraestrutura tecnológica, de
            automação e de intermediação técnica de funcionalidades e recursos digitais, não se
            confundindo com o criador do conteúdo disponibilizado por seus Usuários, nem assumindo
            responsabilidade editorial, comercial ou autoral sobre canais, grupos, bots, materiais,
            ofertas, campanhas ou conteúdos por eles veiculados.
          </p>
          <p>
            1.5. Estes Termos são redigidos em língua portuguesa, que prevalecerá para todos os fins
            de interpretação, validade e aplicação.
          </p>
        </Section>

        <Section title="2. Requisitos e Cadastro">
          <p>2.1. Para realizar cadastro na Plataforma, o Usuário deverá, cumulativamente:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Ser pessoa física maior de 18 (dezoito) anos ou representante legal de pessoa jurídica;</li>
            <li>Ter capacidade civil plena para praticar atos da vida civil;</li>
            <li>Fornecer informações verdadeiras, completas, precisas e atualizadas;</li>
            <li>Aceitar integralmente estes Termos de Uso e a Política de Privacidade da Plataforma.</li>
          </ul>
          <p>
            2.2. O cadastro e o acesso à Plataforma são realizados, em regra, por meio de e-mail e
            senha, diretamente no site {SITE}, sem prejuízo da adoção futura de mecanismos
            adicionais de autenticação, validação ou segurança.
          </p>
          <p>
            2.3. A Spectrum destina-se exclusivamente a pessoas maiores de 18 (dezoito) anos, sendo
            expressamente vedado o cadastro, o acesso ou a utilização da Plataforma por menores de
            idade.
          </p>
          <p>
            2.3.1. Ao se cadastrar e utilizar a Plataforma, o Usuário declara, sob sua
            responsabilidade, que possui idade igual ou superior a 18 (dezoito) anos e plena
            capacidade para contratar.
          </p>
          <p>
            2.3.2. A Spectrum poderá, a seu exclusivo critério, solicitar informações, documentos,
            validações adicionais ou medidas complementares de verificação etária sempre que
            identificar indícios de inconsistência, falsidade, fraude, uso indevido da conta ou
            risco jurídico, regulatório, reputacional ou operacional.
          </p>
          <p>
            2.3.3. Constatada, ou havendo suspeita razoável de, falsidade na declaração de idade, a
            Spectrum poderá suspender ou encerrar a conta de imediato, sem prejuízo das demais
            medidas cabíveis.
          </p>
          <p>
            2.4. O Usuário é integralmente responsável pela guarda, confidencialidade e uso de suas
            credenciais de acesso, respondendo por toda atividade realizada em sua conta até a
            efetiva comunicação de uso indevido à Spectrum, por meio do e-mail {CONTACT_EMAIL}.
          </p>
          <p>
            2.5. O cadastro é pessoal, individual e intransferível, sendo vedado ao Usuário
            compartilhar, ceder, alugar, emprestar, sublicenciar ou de qualquer modo disponibilizar
            sua conta a terceiros sem autorização expressa da Spectrum.
          </p>
        </Section>

        <Section title="3. Modelo de Serviço, Cobrança e Pagamento">
          <p>
            3.1. A Spectrum adota modelo de cobrança por transação, consistente, nesta data, na
            cobrança de taxa fixa de R$ 0,50 (sessenta e quatro centavos) por venda aprovada
            processada por intermédio da estrutura tecnológica da Plataforma, sem mensalidades, sem
            prejuízo de outras tarifas, encargos operacionais, funcionalidades adicionais ou
            condições comerciais informadas na página de preços vigente.
          </p>
          <p>
            3.2. A Plataforma não realiza a cobrança ao consumidor final em nome do Usuário. O
            pagamento do consumidor final é processado pelo gateway de pagamento escolhido pelo
            Usuário, que efetua o repasse direto ao criador, descontadas as taxas aplicáveis.
          </p>
          <p>
            3.3. Os gateways e meios de pagamento integrados, homologados, aceitos ou tecnicamente
            compatíveis com a Plataforma poderão incluir, sem limitação, PushinPay, SyncPay e
            WiinPay, podendo tais integrações ser alteradas, substituídas, suspensas, expandidas ou
            descontinuadas a qualquer tempo, conforme critérios técnicos, operacionais, comerciais,
            regulatórios ou de segurança.
          </p>
          <p>
            3.4. Salvo disposição legal imperativa em sentido contrário, a Spectrum não realizará
            reembolso das taxas cobradas pela utilização da Plataforma quando os serviços
            tecnológicos tiverem sido efetivamente disponibilizados ou utilizados pelo Usuário.
          </p>
          <p>
            3.4.1. O disposto nesta cláusula refere-se exclusivamente às taxas, valores ou
            remunerações devidas à própria Spectrum, não disciplinando reembolsos, chargebacks,
            cancelamentos, disputas ou devoluções relacionados à relação comercial mantida entre o
            Usuário e seus consumidores finais, nem às políticas próprias dos gateways de pagamento
            utilizados.
          </p>
          <p>
            3.5. Na presente data, a Spectrum não opera com planos segmentados, franquias ou níveis
            distintos de assinatura, sendo o acesso estruturado segundo as condições gerais vigentes
            na Plataforma, sem prejuízo de futura alteração do modelo comercial.
          </p>
        </Section>

        <Section title="4. Conteúdo Adulto e Restrições">
          <p>
            4.1. A Spectrum admite a utilização de sua infraestrutura tecnológica para
            operacionalização de canais, grupos e bots que veiculem conteúdo adulto destinado
            exclusivamente a maiores de 18 (dezoito) anos, desde que observadas integralmente a
            legislação aplicável, estes Termos e todas as restrições previstas nesta cláusula.
          </p>
          <p>
            4.2. É expressamente vedado, sob pena de suspensão ou exclusão imediata da conta,
            bloqueio de funcionalidades, preservação de registros e eventual comunicação às
            autoridades competentes, qualquer conteúdo, conduta, material, nomenclatura, campanha,
            oferta ou estratégia que:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              envolva, retrate, sugira, promova ou faça alusão, direta ou indireta, a pornografia
              infantil, exploração sexual de menores ou qualquer forma de abuso, erotização ou
              violência envolvendo pessoas menores de 18 (dezoito) anos;
            </li>
            <li>
              utilize expressões, palavras-chave, nomes de planos, grupos, canais, campanhas,
              descrições, códigos, abreviações ou terminologias que remetam, ainda que de forma
              disfarçada, ambígua, codificada, simbólica ou sugestiva, a conteúdo ilegal envolvendo
              menores;
            </li>
            <li>
              envolva, retrate ou promova abuso ou exploração sexual de animais, ou qualquer outra
              prática criminosa de natureza equivalente;
            </li>
            <li>
              seja ilícito, discriminatório, difamatório, fraudulento, obsceno em desconformidade
              com a legislação aplicável, violento ou apto a incitar ódio, crime ou qualquer
              atividade ilícita;
            </li>
            <li>
              viole direitos de imagem, privacidade, honra, personalidade, autoria, propriedade
              intelectual ou quaisquer direitos de terceiros.
            </li>
          </ul>
          <p>
            4.3. O conteúdo publicado, ofertado, transmitido, divulgado ou comercializado pelo
            Usuário em seus canais, grupos, bots, páginas, campanhas ou comunicações é de sua
            exclusiva responsabilidade civil, administrativa e criminal, não cabendo à Spectrum
            responsabilidade editorial prévia sobre tal material.
          </p>
          <p>
            4.3.1. Sem prejuízo disso, a Spectrum poderá agir de ofício ou mediante denúncia para
            limitar funcionalidades, suspender, bloquear ou encerrar contas que violem estes Termos,
            a legislação aplicável ou apresentem risco jurídico, regulatório, reputacional, técnico
            ou operacional, inclusive por meio de mecanismos automatizados de filtragem de termos e
            conteúdos.
          </p>
          <p>
            4.4. O Usuário declara e garante que adotará todas as cautelas razoáveis para que o
            conteúdo por ele disponibilizado por meio da infraestrutura da Spectrum seja destinado
            exclusivamente a maiores de 18 (dezoito) anos, responsabilizando-se integralmente por
            acessos indevidos, informações falsas, violações legais ou qualquer uso irregular
            relacionado ao seu ambiente, inclusive perante terceiros e autoridades competentes.
          </p>
        </Section>

        <Section title="5. Obrigações do Usuário">
          <p>
            5.1. Sem prejuízo de outras obrigações previstas nestes Termos e na legislação
            aplicável, o Usuário obriga-se a:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>utilizar a Plataforma de forma ética, lícita, leal e compatível com sua finalidade;</li>
            <li>
              não fraudar, contornar, interferir, testar indevidamente, explorar vulnerabilidades,
              realizar engenharia reversa ou tentar manipular a infraestrutura, o funcionamento, a
              lógica, os fluxos ou os mecanismos de segurança da Plataforma;
            </li>
            <li>
              não utilizar scripts, automações externas, robôs, crawlers ou quaisquer meios
              automatizados não autorizados, salvo os recursos expressamente disponibilizados pela
              própria Spectrum;
            </li>
            <li>manter seus dados cadastrais corretos, completos e atualizados;</li>
            <li>
              não criar, utilizar ou manter múltiplas contas com o objetivo de contornar limitações,
              suspensões, bloqueios, regras operacionais ou políticas internas;
            </li>
            <li>
              cumprir integralmente os Termos de Serviço, políticas e regras do Telegram, dos
              gateways de pagamento e de quaisquer serviços de terceiros integrados ou utilizados em
              conjunto com a Plataforma;
            </li>
            <li>
              responder integralmente pelos conteúdos, ofertas, campanhas, acessos, cobranças,
              comunicações e atividades vinculadas à sua conta.
            </li>
          </ul>
        </Section>

        <Section title="6. Suspensão e Exclusão da Conta">
          <p>
            6.1. A Spectrum poderá, a seu exclusivo critério e independentemente de ordem judicial
            prévia, restringir funcionalidades, suspender temporariamente ou encerrar
            definitivamente contas, com ou sem aviso prévio, conforme a gravidade do caso, sempre
            que verificar, ou houver indícios razoáveis de:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>fraude, tentativa de fraude ou uso indevido da Plataforma;</li>
            <li>
              inadimplência, chargeback relevante, disputa reiterada ou descumprimento de obrigações
              financeiras relacionadas à utilização da Plataforma;
            </li>
            <li>
              violação destes Termos, da Política de Privacidade ou de quaisquer políticas,
              diretrizes ou regras aplicáveis;
            </li>
            <li>
              utilização da Plataforma para atividades ilegais, abusivas, fraudulentas, simuladas ou
              não autorizadas;
            </li>
            <li>
              publicação, distribuição, comercialização ou intermediação de conteúdo ilegal,
              inclusive material relacionado à exploração sexual de menores ou qualquer outra
              prática vedada por lei;
            </li>
            <li>
              utilização de termos, descrições, nomes, expressões, campanhas, estruturas ou
              classificações que façam alusão direta ou indireta a conteúdo ilícito envolvendo
              menores;
            </li>
            <li>
              violação de direitos de terceiros, inclusive de propriedade intelectual, imagem,
              privacidade, personalidade ou proteção de dados;
            </li>
            <li>
              envio, armazenamento, transmissão ou disseminação de vírus, malware, scripts
              maliciosos ou outros códigos nocivos;
            </li>
            <li>
              tentativa de acesso não autorizado, intrusão, exploração de vulnerabilidades ou
              qualquer conduta apta a comprometer a segurança, estabilidade ou integridade da
              Plataforma;
            </li>
            <li>
              conduta que exponha a Spectrum a risco jurídico, regulatório, reputacional, técnico,
              comercial ou operacional.
            </li>
          </ul>
          <p>
            6.2. Nos casos de suspensão, bloqueio ou encerramento da conta motivados por infração
            imputável ao Usuário, a Spectrum poderá reter os valores já cobrados ou devidos pela
            disponibilização da infraestrutura tecnológica até a data da medida adotada, sem
            obrigação de restituição proporcional de quantias relativas ao período remanescente,
            ressalvadas as hipóteses em que a restituição seja expressamente exigida por norma
            cogente aplicável.
          </p>
        </Section>

        <Section title="7. Limitação de Responsabilidade">
          <p>
            7.1. A Spectrum disponibiliza infraestrutura tecnológica e recursos de automação para
            uso pelos Usuários, não se responsabilizando, em caráter editorial, comercial ou
            autoral, pelos conteúdos, ofertas, cobranças, campanhas, materiais, promessas,
            interações, comunicações ou práticas adotadas pelos Usuários perante seus assinantes,
            clientes ou terceiros.
          </p>
          <p>
            7.2. Sem prejuízo das hipóteses em que a legislação aplicável imponha responsabilidade
            inderrogável, a Spectrum não se responsabiliza por prejuízos decorrentes de:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              conteúdo, condutas, ofertas, cobranças, campanhas ou materiais publicados ou operados
              pelos Usuários;
            </li>
            <li>
              falhas, instabilidades, atrasos, indisponibilidades, bloqueios ou políticas próprias
              do Telegram;
            </li>
            <li>
              falhas, indisponibilidades, retenções, bloqueios, chargebacks, recusas, limitações,
              suspensões ou políticas dos gateways e meios de pagamento utilizados pelo Usuário;
            </li>
            <li>
              falhas, incidentes ou indisponibilidades causadas por terceiros, inclusive provedores
              de hospedagem, integrações, serviços de mensageria, APIs, infraestrutura de nuvem ou
              ferramentas externas;
            </li>
            <li>
              uso indevido, negligente, fraudulento ou incompatível da Plataforma pelo Usuário ou
              por terceiros que tenham acessado sua conta;
            </li>
            <li>
              fraudes, golpes, acessos indevidos, invasões, incidentes externos ou eventos de
              segurança não causados exclusivamente por falha comprovadamente imputável à Spectrum;
            </li>
            <li>
              danos indiretos, lucros cessantes, perda de chance, prejuízos reputacionais reflexos
              ou danos decorrentes de fatos de terceiros ou de circunstâncias fora do controle
              razoável da Plataforma.
            </li>
          </ul>
          <p>
            7.3. Salvo previsão expressa em contrário, a Spectrum não garante disponibilidade
            ininterrupta, nível mínimo de uptime ou SLA específico. A Plataforma será
            disponibilizada segundo os melhores esforços razoáveis, podendo sofrer
            indisponibilidades, interrupções, manutenções, ajustes, falhas ou limitações decorrentes
            de fatores técnicos próprios ou de terceiros.
          </p>
          <p>
            7.4. Na hipótese de descontinuação definitiva da Plataforma, a Spectrum buscará
            comunicar os Usuários com antecedência razoável, sempre que isso for técnica,
            operacional e juridicamente possível, podendo estabelecer período de transição,
            limitação progressiva de funcionalidades ou orientações gerais para encerramento da
            utilização, sem prejuízo de encerramentos imediatos quando exigidos por razões legais,
            regulatórias, de segurança ou força maior.
          </p>
        </Section>

        <Section title="8. Propriedade Intelectual">
          <p>
            8.1. A marca Spectrum, seu logotipo, identidade visual, layout, fluxos, interfaces,
            código-fonte, arquitetura, banco de dados, funcionalidades e demais ativos digitais
            vinculados à Plataforma são protegidos pela legislação aplicável de propriedade
            intelectual, sendo de uso exclusivo da Spectrum ou de seus legítimos titulares ou
            licenciadores.
          </p>
          <p>
            8.2. O uso da Plataforma pelo Usuário não implica cessão, transferência, sublicença,
            autorização de exploração econômica ou qualquer outra forma de disponibilização dos
            direitos de propriedade intelectual relacionados à Spectrum, exceto na medida
            estritamente necessária ao uso regular das funcionalidades oferecidas.
          </p>
          <p>
            8.3. O conteúdo inserido, publicado, disponibilizado ou operacionalizado pelo Usuário
            por meio da Plataforma permanece sob sua exclusiva titularidade ou responsabilidade,
            conforme a natureza do direito aplicável, não implicando, por si só, transferência de
            propriedade intelectual à Spectrum.
          </p>
          <p>
            8.4. É vedado reproduzir, copiar, adaptar, modificar, desmontar, traduzir, distribuir,
            sublicenciar, disponibilizar, comercializar, realizar engenharia reversa ou explorar, no
            todo ou em parte, a Plataforma ou quaisquer de seus elementos protegidos, salvo
            autorização prévia e expressa da Spectrum ou hipótese legalmente admitida.
          </p>
        </Section>

        <Section title="9. Proteção de Dados — LGPD">
          <p>
            9.1. O tratamento de dados pessoais realizado no contexto da utilização da Plataforma
            observará a legislação aplicável, em especial a Lei nº 13.709/2018 (LGPD), bem como as
            disposições previstas na Política de Privacidade da Spectrum, a qual integra estes
            Termos para todos os fins.
          </p>
          <p>
            9.2. As comunicações relacionadas a privacidade, proteção de dados pessoais e exercício
            de direitos de titulares poderão ser encaminhadas para o canal {CONTACT_EMAIL}, sem
            prejuízo da adoção de outros canais específicos que venham a ser disponibilizados na
            Política de Privacidade ou na própria Plataforma.
          </p>
          <p>
            9.3. O titular dos dados poderá exercer, nos termos da legislação aplicável, os direitos
            legalmente cabíveis, inclusive acesso, correção, atualização, anonimização, eliminação,
            oposição, informação sobre compartilhamentos e demais prerrogativas previstas em lei,
            mediante solicitação encaminhada ao canal indicado pela Spectrum, observadas as
            hipóteses legais de retenção, conservação e exercício regular de direitos.
          </p>
        </Section>

        <Section title="10. Comunicações e Marketing">
          <p>
            10.1. A Spectrum poderá encaminhar ao Usuário comunicações operacionais, transacionais,
            informativas ou de segurança indispensáveis à execução da relação contratual, ao
            funcionamento da conta ou à integridade da Plataforma.
          </p>
          <p>
            10.2. Comunicações de natureza promocional, publicitária ou mercadológica dependerão,
            quando exigido por lei, de base legal apropriada, especialmente consentimento quando
            aplicável, podendo o Usuário revogar a autorização correspondente pelos meios
            disponibilizados.
          </p>
        </Section>

        <Section title="11. Alterações dos Termos">
          <p>
            11.1. A Spectrum poderá alterar, atualizar, complementar ou substituir estes Termos de
            Uso a qualquer tempo, mediante disponibilização da versão atualizada na Plataforma, com
            indicação da respectiva data de vigência.
          </p>
          <p>
            11.2. Alterações que impactem de modo relevante os direitos ou obrigações do Usuário
            serão, sempre que possível, comunicadas com antecedência razoável por e-mail, aviso
            interno, banner, notificação na Plataforma ou outro meio idôneo.
          </p>
          <p>
            11.3. Caso o Usuário não concorde com a nova redação, poderá cessar a utilização da
            Plataforma e solicitar o encerramento de sua conta antes da entrada em vigor da versão
            atualizada. A continuidade de uso após a vigência da nova versão será interpretada como
            aceitação dos novos Termos.
          </p>
        </Section>

        <Section title="12. Disposições Gerais">
          <p>
            12.1. Estes Termos constituem o acordo integral entre a Spectrum e o Usuário no tocante
            ao uso da Plataforma, prevalecendo sobre entendimentos, comunicações ou versões
            anteriores acerca do mesmo objeto.
          </p>
          <p>
            12.2. A eventual tolerância quanto ao descumprimento de qualquer disposição destes
            Termos não importará em novação, renúncia, alteração tácita ou precedente vinculante.
          </p>
          <p>
            12.3. Se qualquer disposição destes Termos vier a ser considerada inválida, nula, ilegal
            ou inexequível, as demais disposições permanecerão válidas e eficazes, na máxima
            extensão admitida pela legislação aplicável.
          </p>
          <p>
            12.4. Estes Termos serão regidos e interpretados de acordo com a legislação da República
            Federativa do Brasil, incluindo, conforme a natureza da relação jurídica concretamente
            estabelecida, o Código Civil, a Lei Geral de Proteção de Dados Pessoais (Lei nº
            13.709/2018) e, quando cabível, o Código de Defesa do Consumidor.
          </p>
          <p>
            12.5. Reclamações, notificações, solicitações e dúvidas relacionadas à Plataforma
            poderão ser encaminhadas pelo Usuário ao e-mail {CONTACT_EMAIL} ou aos canais oficiais
            de suporte divulgados no site {SITE}.
          </p>
        </Section>

        <Section title="13. Foro">
          <p>
            13.1. Para dirimir controvérsias oriundas destes Termos, será competente o foro do
            domicílio do consumidor, nas hipóteses em que a legislação consumerista assim
            determinar. Nas demais relações de natureza empresarial ou não consumerista, fica eleito
            o foro da Comarca de João Pessoa/PB, com renúncia a qualquer outro, por mais
            privilegiado que seja.
          </p>
        </Section>

        <footer className="mt-16 border-t border-white/10 pt-8 text-center text-xs text-slate-500">
          <p className="font-semibold text-slate-400 tracking-widest uppercase">Spectrum</p>
          <p className="mt-2">
            {CONTACT_EMAIL} | {SITE}
          </p>
          <p className="mt-1">
            Versão {VERSION} — {LAST_UPDATE}
          </p>
          <div className="mt-6">
            <Link to="/" className="text-violet-400 hover:text-violet-300">
              ← Voltar
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default TermsOfUse;
